import { XMLParser } from 'fast-xml-parser';
import { createContext, useContext, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

export const SheetCorrectionContext = createContext(null);

export const useSheetCorrection = () => {
	return useContext(SheetCorrectionContext);
};

export default function SheetCorrectionProvider(props) {
	const [stage, setStage] = useState(null);
	const [lattices, setLattices] = useState([]);
	const [data, setData] = useState([]);
	const { getValues } = useFormContext();
	const latticesXml = getValues('latticesXML');

	useEffect(() => {
		if (latticesXml && lattices.length === 0) {
			const parser = new XMLParser({ ignoreAttributes: false, attributeNamePrefix: '__' });
			const _lattices = parser.parse(latticesXml);
			const result = _lattices.CPPLattice.CPPLatticeRow.map(r => {
				return {
					error_code: Number.parseInt(r.__error_code, 10),
					kerdes_id: Number.parseInt(r.__kerdes_id, 10),
					marker: Number.parseInt(r.__marker, 10),
					supervised: r.__supervised === 'True',
					torolt: r.__torolt === 'True',
					valasz: Number.parseInt(r.__valasz, 10),
					valasz_id: Number.parseInt(r.__valasz_id, 10),
					vizsgazo_valasz_id: Number.parseInt(r.__vizsgazo_valasz_id, 10),
					cols: r.CPPLatticeCol.map(c => {
						return {
							helyes: c.__helyes === 'True',
							marker: Number.parseInt(c.__marker, 10),
							selected: Number.parseInt(c.__selected, 10),
							valasz_id: Number.parseInt(c.__valasz_id, 10),
							x: Number.parseInt(c.__x, 10),
							y: Number.parseInt(c.__y, 10)
						};
					})
				};
			});
			setLattices(result);
		}
	}, [latticesXml, lattices]);

	const changeCursor = cursorType => {
		stage.container().style.cursor = cursorType;
	};

	const value = { stage, setStage, data, setData, lattices, changeCursor };
	return <SheetCorrectionContext.Provider value={value}>{props.children}</SheetCorrectionContext.Provider>;
}
